import React from "react";
import { Button, Modal } from "react-bootstrap";

import { CallRegistry } from "./callRegistry";
import { useCallsExplorer } from "./callsExplorerContext";

export const RelatedCallsModal: React.FC = () => {
  const { relatedCallsTarget, closeRelatedCalls, viewInMainList } = useCallsExplorer();

  const title = !relatedCallsTarget
    ? ""
    : relatedCallsTarget.dimension === "calling_name"
      ? `Calls handled by ${relatedCallsTarget.label}`
      : relatedCallsTarget.dimension === "caller_id"
        ? `Calls from ${relatedCallsTarget.label}`
        : `Calls to ${relatedCallsTarget.label}`;

  return (
    <Modal show={!!relatedCallsTarget} onHide={closeRelatedCalls} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {relatedCallsTarget && (
          <CallRegistry
            filters={{
              [relatedCallsTarget.dimension]: relatedCallsTarget.value,
            }}
            emptyMessage="No other calls found."
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() => {
            if (relatedCallsTarget) {
              viewInMainList(relatedCallsTarget.dimension, relatedCallsTarget.value);
            }
          }}
        >
          View full results
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
